import createStyles from '@guestyci/foundation/createStyles';
import { Link } from 'react-router-dom';
import { Col } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import ForgotPasswordForm from 'app/module/Authorization/ForgotPasswordForm';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';
import navigationsRoute from 'app/routes/navigationsRoute';
import iconArrowBack from 'assets/icons/arrow-back.svg';
import Layout from 'app/shareable/layouts/Layout';

const useStyles = createStyles((theme: typeof defaultTheme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.dark,
    marginBottom: '.5rem',
    '&:hover': {
      color: theme.palette.text.dark,
    },
  },
  rootForm: {
    maxWidth: '400px',
  },
}));

export default function ForgotPasswordPage() {
  const classes = useCustomTextFieldStyles();
  const commonClasses = useStyles();

  return (
    <Layout captureText="Get More Eyes On Your Rentals!">
      <Col>
        <div className="mb-10">
          <Link className={commonClasses.link} to={navigationsRoute.LOGIN_PAGE}>
            <img src={iconArrowBack} alt="go back" className="mr-1" />
            Back to Login
          </Link>
          <TextField className={classes.h1}>Forgot Your Password? </TextField>
          <div className="mt-2">
            <TextField className={classes.h3}>
              Please enter your email address to reset your password.
            </TextField>
          </div>
        </div>
        <Col className={commonClasses.rootForm}>
          <ForgotPasswordForm />
        </Col>
      </Col>
    </Layout>
  );
}
